import { useLanguage } from "../../contexts/LanguageContext";

const COPY = {
    en: {
        eyebrow: "04 — How it works",
        title: "From free signup to first spend",
        highlight: "in minutes",
        steps: [
            { title: "Create your free account", text: "Sign up with your name, email and password. No card, no subscription, no approval queue — your panel is live instantly." },
            { title: "Fund your wallet", text: "Send USDT (TRC-20 / ERC-20) or USDC to your personal deposit address. The chain is watched automatically and your balance is credited after confirmation." },
            { title: "Request an account & launch", text: "Pick Meta, Google, TikTok, Snapchat, Bing, Taboola or Outbrain, submit the request and your whitelisted account is provisioned — typically in under 5 minutes." },
        ],
    },
    tr: {
        eyebrow: "04 — Nasıl çalışır",
        title: "Ücretsiz kayıttan ilk harcamaya",
        highlight: "dakikalar içinde",
        steps: [
            { title: "Ücretsiz hesabını oluştur", text: "Ad, e-posta ve şifreyle kayıt ol. Kart yok, abonelik yok, onay kuyruğu yok — panelin anında açılır." },
            { title: "Cüzdanını yükle", text: "Sana özel yatırım adresine USDT (TRC-20 / ERC-20) veya USDC gönder. Zincir otomatik izlenir, onay sonrası bakiyen yüklenir." },
            { title: "Hesap talep et ve yayına al", text: "Meta, Google, TikTok, Snapchat, Bing, Taboola veya Outbrain'i seç, talebi gönder; whitelisted hesabın genellikle 5 dakikadan kısa sürede hazır olur." },
        ],
    },
    es: {
        eyebrow: "04 — Cómo funciona",
        title: "Del registro gratuito al primer gasto",
        highlight: "en minutos",
        steps: [
            { title: "Crea tu cuenta gratis", text: "Regístrate con nombre, correo y contraseña. Sin tarjeta, sin suscripción, sin cola de aprobación — tu panel se activa al instante." },
            { title: "Fondea tu wallet", text: "Envía USDT (TRC-20 / ERC-20) o USDC a tu dirección personal de depósito. La cadena se monitorea automáticamente y el saldo se acredita tras la confirmación." },
            { title: "Solicita una cuenta y lanza", text: "Elige Meta, Google, TikTok, Snapchat, Bing, Taboola u Outbrain, envía la solicitud y tu cuenta whitelisted se aprovisiona — normalmente en menos de 5 minutos." },
        ],
    },
    pt: {
        eyebrow: "04 — Como funciona",
        title: "Do cadastro grátis ao primeiro gasto",
        highlight: "em minutos",
        steps: [
            { title: "Crie sua conta grátis", text: "Cadastre-se com nome, e-mail e senha. Sem cartão, sem assinatura, sem fila de aprovação — seu painel fica ativo na hora." },
            { title: "Abasteça sua wallet", text: "Envie USDT (TRC-20 / ERC-20) ou USDC para seu endereço pessoal de depósito. A rede é monitorada automaticamente e o saldo é creditado após a confirmação." },
            { title: "Solicite uma conta e lance", text: "Escolha Meta, Google, TikTok, Snapchat, Bing, Taboola ou Outbrain, envie a solicitação e sua conta whitelisted é provisionada — normalmente em menos de 5 minutos." },
        ],
    },
    ru: {
        eyebrow: "04 — Как это работает",
        title: "От бесплатной регистрации до первого спенда",
        highlight: "за минуты",
        steps: [
            { title: "Создайте бесплатный аккаунт", text: "Регистрация по имени, e-mail и паролю. Без карты, без подписки, без очереди на одобрение — панель доступна сразу." },
            { title: "Пополните кошелёк", text: "Отправьте USDT (TRC-20 / ERC-20) или USDC на ваш личный адрес депозита. Сеть отслеживается автоматически, баланс зачисляется после подтверждения." },
            { title: "Запросите аккаунт и запускайте", text: "Выберите Meta, Google, TikTok, Snapchat, Bing, Taboola или Outbrain, отправьте запрос — whitelisted-аккаунт выдаётся обычно менее чем за 5 минут." },
        ],
    },
};

export default function HowItWorksSection() {
    const { language } = useLanguage();
    const c = COPY[language] || COPY.en;

    return (
        <section id="how" data-testid="how-it-works-section" className="py-24 md:py-32 relative">
            <div className="container-skala">
                <div className="max-w-3xl mb-14 space-y-4">
                    <p className="text-[11px] font-mono uppercase tracking-[0.3em] text-highlight">{c.eyebrow}</p>
                    <h2 className="font-display font-semibold text-4xl md:text-5xl tracking-tight">
                        {c.title} <span className="serif-accent text-foreground/85">{c.highlight}</span>.
                    </h2>
                </div>

                <div className="grid md:grid-cols-3 gap-5 md:gap-6">
                    {c.steps.map((s, i) => (
                        <div key={i} data-testid={`step-card-${i}`} className="relative bg-card border border-white/[0.07] rounded-2xl p-8 hover:border-white/20 transition-colors">
                            <div className="font-display font-black text-7xl text-primary/15 leading-none mb-4">{String(i + 1).padStart(2, "0")}</div>
                            <h3 className="font-display font-semibold text-2xl mb-3">{s.title}</h3>
                            <p className="text-muted-foreground leading-relaxed">{s.text}</p>
                            {i < c.steps.length - 1 && <div className="hidden md:block absolute top-1/2 -right-3 w-6 h-px bg-white/10" />}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
